export default {
    CHANGE_DATA: '@__CHANGE_THEME',
    CHANGE_TEMPLATE: '@__CHANGE_TEMPLATE_NAME',
    SAVE_WEEK: '@__SAVE_WEEK',
};
